import { useParams, Link } from 'react-router-dom';
import SEOMeta from '@/components/feature/SEOMeta';
import { categoryVideos, categoryMeta, VideoItem } from '@/mocks/category';

const categorySlugMap: Record<string, string> = {
  dianying: 'movie',
  dianshiju: 'tv',
  zongyi: 'variety',
  dongman: 'anime',
  jilupian: 'documentary',
  zixun: 'news',
};

const categoryNameMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  zixun: '资讯',
};

const categoryImages: Record<string, Record<string, string>> = {
  dianying: {
    m1: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20space%20station%20and%20Earth%20in%20background%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20minimalist%20design%2C%20clean%20dark%20background%20with%20orange%20accents%2C%20high%20detail%2C%208K%20quality&width=600&height=800&seq=cat-movie-01&orientation=portrait",
    m2: "https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20film%20poster%2C%20ancient%20Chinese%20palace%20silhouette%2C%20mystical%20clouds%20and%20golden%20light%2C%20dramatic%20composition%2C%20warm%20tone%2C%20cinematic%20atmosphere%2C%208K%20quality&width=600&height=800&seq=cat-movie-02&orientation=portrait",
    m3: "https://readdy.ai/api/search-image?query=Historical%20drama%20film%20poster%2C%20atomic%20age%20aesthetic%2C%20dramatic%20explosion%20silhouette%20in%20warm%20orange%20and%20dark%20contrast%2C%20minimalist%20cinematic%20design%2C%20intense%20atmosphere%2C%208K%20quality&width=600&height=800&seq=cat-movie-03&orientation=portrait",
    m4: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%2C%20warm%20family%20living%20room%20scene%2C%20soft%20golden%20sunlight%20through%20window%2C%20cozy%20atmosphere%2C%20lighthearted%20mood%2C%20clean%20composition%2C%208K%20quality&width=600&height=800&seq=cat-movie-04&orientation=portrait",
    m5: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20desert%20planet%20poster%2C%20massive%20sand%20dunes%20under%20golden%20sun%2C%20mysterious%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20and%20sandy%20tones%2C%20dramatic%20lighting%2C%208K%20quality&width=600&height=800&seq=cat-movie-05&orientation=portrait",
    m6: "https://readdy.ai/api/search-image?query=Chinese%20inspirational%20sports%20film%20poster%2C%20boxing%20ring%20with%20warm%20spotlight%2C%20athletic%20silhouette%2C%20dynamic%20motion%2C%20warm%20golden%20lighting%2C%20powerful%20composition%2C%208K%20quality&width=600&height=800&seq=cat-movie-06&orientation=portrait",
    m7: "https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20film%20poster%2C%20modern%20office%20party%20scene%2C%20warm%20indoor%20lighting%2C%20festive%20atmosphere%2C%20humorous%20mood%2C%20clean%20corporate%20aesthetic%2C%208K%20quality&width=600&height=800&seq=cat-movie-07&orientation=portrait",
    m8: "https://readdy.ai/api/search-image?query=Pink%20themed%20fantasy%20film%20poster%2C%20dreamy%20dollhouse%20aesthetic%2C%20warm%20pastel%20tones%2C%20whimsical%20atmosphere%2C%20creative%20set%20design%20style%2C%20soft%20lighting%2C%208K%20quality&width=600&height=800&seq=cat-movie-08&orientation=portrait",
  },
  dianshiju: {
    t1: "https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20drama%20poster%2C%20neon%20lights%20at%20night%2C%20urban%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20photography%20style%2C%20soft%20focus%20background%2C%20elegant%20composition%2C%208K%20quality&width=600&height=800&seq=cat-tv-01&orientation=portrait",
    t2: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%2C%20urban%20night%20scene%20with%20rain%20on%20streets%2C%20moody%20atmospheric%20lighting%2C%20dark%20warm%20tones%2C%20cinematic%20film%20noir%20style%2C%20suspenseful%20composition%2C%208K%20quality&width=600&height=800&seq=cat-tv-02&orientation=portrait",
    t3: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20poster%2C%20northern%20small%20town%20in%20autumn%2C%20golden%20leaves%20and%20warm%20nostalgic%20lighting%2C%20melancholic%20atmosphere%2C%20cinematic%20composition%2C%208K%20quality&width=600&height=800&seq=cat-tv-03&orientation=portrait",
    t4: "https://readdy.ai/api/search-image?query=Sci-fi%20thriller%20TV%20series%20poster%2C%20cosmic%20background%20with%20three%20suns%2C%20mysterious%20alien%20signal%20waves%2C%20dark%20and%20warm%20contrast%2C%20intellectual%20atmosphere%2C%208K%20quality&width=600&height=800&seq=cat-tv-04&orientation=portrait",
    t5: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20ancient%20palace%20courtyard%2C%20warm%20golden%20sunlight%2C%20elegant%20costume%20design%20aesthetic%2C%20atmospheric%20mist%2C%20cinematic%20composition%2C%208K%20quality&width=600&height=800&seq=cat-tv-05&orientation=portrait",
    t6: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20romance%20drama%20poster%2C%20celestial%20realm%20with%20floating%20clouds%20and%20phoenix%2C%20warm%20golden%20and%20rose%20tones%2C%20ethereal%20atmosphere%2C%20elegant%20flowing%20fabric%2C%208K%20quality&width=600&height=800&seq=cat-tv-06&orientation=portrait",
  },
};

const defaultCategoryImages: Record<string, string> = {
  zongyi: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20sports%20theme%2C%20bright%20warm%20sunlight%2C%20energetic%20atmosphere%2C%20colorful%20and%20vibrant%20composition%2C%208K%20quality&width=600&height=800&seq=cat-variety-default&orientation=portrait",
  dongman: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20poster%2C%20fire%20and%20water%20elements%20intertwining%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20warm%20orange%20and%20gold%20colors%2C%20cinematic%20rendering%2C%208K%20quality&width=600&height=800&seq=cat-anime-default&orientation=portrait",
  jilupian: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20breathtaking%20landscape%20with%20mountains%20and%20ocean%2C%20golden%20hour%20lighting%2C%20warm%20natural%20tones%2C%20aerial%20photography%20style%2C%20serene%20epic%20composition%2C%208K%20quality&width=600&height=800&seq=cat-doc-default&orientation=portrait",
  zixun: "https://readdy.ai/api/search-image?query=Chinese%20cinema%20box%20office%20news%20visual%2C%20modern%20movie%20theater%20entrance%20with%20warm%20red%20and%20gold%20festive%20decorations%2C%20bustling%20crowd%2C%20celebratory%20atmosphere%2C%208K%20quality&width=600&height=800&seq=cat-news-default&orientation=portrait",
};

function getImage(catSlug: string, video: VideoItem): string {
  if (categoryImages[catSlug] && categoryImages[catSlug][video.id]) {
    return categoryImages[catSlug][video.id];
  }
  if (catSlug === 'dianshiju') {
    return "https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20poster%2C%20warm%20living%20room%20lighting%2C%20family%20drama%20atmosphere%2C%20cozy%20and%20emotional%20composition%2C%20cinematic%20style%2C%208K%20quality&width=600&height=800&seq=cat-tv-default&orientation=portrait";
  }
  return defaultCategoryImages[catSlug] || defaultCategoryImages.dongman;
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const catSlug = slug || 'dianying';
  const videos = categoryVideos[catSlug] || [];
  const meta = categoryMeta[catSlug] || categoryMeta.dianying;
  const catName = categoryNameMap[catSlug] || '电影';

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://mangovideo.com/' },
      { '@type': 'ListItem', position: 2, name: catName, item: `https://mangovideo.com/category/${catSlug}` },
    ],
  };

  return (
    <>
      <SEOMeta
        title={meta.title}
        description={meta.description}
        keywords={`芒果视频,芒果视频${catName},${catName}高清,${catName}在线观看,免费${catName}`}
        canonicalUrl={`https://mangovideo.com/category/${catSlug}`}
        schema={breadcrumbSchema}
      />

      <main className="pt-16">
        <nav className="px-4 md:px-6 py-4 bg-background-100 border-b border-background-200/70" aria-label="面包屑导航">
          <div className="max-w-7xl mx-auto">
            <ol className="flex items-center gap-2 text-xs text-foreground-400">
              <li><Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-foreground-700 font-medium">{catName}</li>
            </ol>
          </div>
        </nav>

        <section className="py-10 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="mb-10">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                {catName}
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl">
                {meta.description}
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {Object.entries(categoryNameMap).map(([key, name]) => (
                <Link
                  key={key}
                  to={`/category/${key}`}
                  className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                    catSlug === key
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                  }`}
                >
                  {name}
                </Link>
              ))}
            </div>

            {videos.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-foreground-400">暂无内容</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                {videos.map((video) => (
                  <div key={video.id} className="group cursor-pointer">
                    <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                      <img
                        src={getImage(catSlug, video)}
                        alt={video.title}
                        title={`${video.title} - 芒果视频${catName}高清在线观看`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                          <i className="ri-play-fill text-lg"></i>
                        </div>
                      </div>
                      {video.rating > 0 && (
                        <div className="absolute top-2 right-2 bg-background-900/70 backdrop-blur-sm text-accent-400 text-xs font-semibold px-2 py-1 rounded-md">
                          {video.rating}
                        </div>
                      )}
                    </div>
                    <h3 className="font-semibold text-foreground-800 text-sm md:text-base truncate">
                      {video.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400 flex-wrap">
                      <span>{video.year}</span>
                      <span>·</span>
                      <span>{video.region}</span>
                      <span>·</span>
                      <span>{video.views}次播放</span>
                    </div>
                    <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                      {video.description}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}